import { UserRole } from '@/lib/enums';

const ROLE_PRIORITY: Record<UserRole, number> = {
  [UserRole.admin]: 3,
  [UserRole.kitchen]: 2,
  [UserRole.employee]: 1,
};

const VALID_ROLES = new Set<string>(Object.values(UserRole));

/**
 * Determines the highest-priority role from an array of role strings.
 *
 * Priority: admin > kitchen > employee
 *
 * Client-safe (no server imports). Use this everywhere a "primary role"
 * is needed so the resolution logic is consistent across the codebase.
 */
export function getPrimaryRole(roles: string[] | undefined | null): UserRole {
  if (!roles || roles.length === 0) return UserRole.employee;

  let best: UserRole = UserRole.employee;
  let bestPriority = 0;

  for (const r of roles) {
    if (VALID_ROLES.has(r)) {
      const priority = ROLE_PRIORITY[r as UserRole];
      if (priority > bestPriority) {
        bestPriority = priority;
        best = r as UserRole;
      }
    }
  }

  return best;
}
